import React from "react";
import { graphql, useFragment, useMutation } from "react-relay";

import { PrioritySelector } from "../../../WorkspaceTodoSignalShared/PrioritySelector";
import { WorkspaceSignalEditMainPrioritySelector_Signal$key } from "./__generated__/WorkspaceSignalEditMainPrioritySelector_Signal.graphql";
import { WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation } from "./__generated__/WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation.graphql";

export function SignalPrioritySelector(props: {
  signal: WorkspaceSignalEditMainPrioritySelector_Signal$key;
  disabled: boolean;
}) {
  const data = useFragment(
    graphql`
      fragment WorkspaceSignalEditMainPrioritySelector_Signal on SignalWorkspace {
        id
        priority
        updatedAtDate {
          ...FormattedDate
          isoString
        }
        updatedBy {
          name
          id
        }
      }
    `,
    props.signal
  );

  const [setPriorityMutation] =
    useMutation<WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation>(
      graphql`
        mutation WorkspaceSignalEditMainPrioritySelectorSetPriorityMutation(
          $id: ID!
          $priority: SignalPriority!
        ) @raw_response_type {
          signalWorkspace(id: $id) {
            updatePriority(newPriority: $priority) {
              id
              priority
              updatedAtDate {
                ...FormattedDate
              }
              updatedBy {
                name
                id
              }
            }
          }
        }
      `
    );

  return (
    <PrioritySelector
      disabled={props.disabled}
      selectedPriority={data.priority}
      onValueChange={(prio) => {
        setPriorityMutation({
          optimisticResponse: {
            signalWorkspace: {
              updatePriority: {
                id: data.id,
                priority: prio,
                updatedAtDate: data.updatedAtDate
                  ? {
                      ...data.updatedAtDate,
                      __isDate: "UnzonedDate" as const,
                    }
                  : null,

                updatedBy: data.updatedBy,
              },
            },
          },
          variables: {
            id: data.id,
            priority: prio,
          },
        });
      }}
    />
  );
}
